export const countryTimezones = {
  'AD': ['Europe/Andorra'],
  'AE': ['Asia/Dubai'],
  'AF': ['Asia/Kabul'],
  'AG': ['America/Antigua'],
  'AI': ['America/Anguilla'],
  'AL': ['Europe/Tirane'],
  'AM': ['Asia/Yerevan'],
  'AO': ['Africa/Luanda'],
  'AQ': ['Antarctica/McMurdo', 'Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Mawson', 'Antarctica/Palmer', 'Antarctica/Rothera', 'Antarctica/Syowa', 'Antarctica/Troll', 'Antarctica/Vostok'],
  'AR': ['America/Argentina/Buenos_Aires', 'America/Argentina/Cordoba', 'America/Argentina/Salta', 'America/Argentina/Jujuy', 'America/Argentina/Tucuman', 'America/Argentina/Catamarca', 'America/Argentina/La_Rioja', 'America/Argentina/San_Juan', 'America/Argentina/Mendoza', 'America/Argentina/San_Luis', 'America/Argentina/Rio_Gallegos', 'America/Argentina/Ushuaia'],
  'AS': ['Pacific/Pago_Pago'],
  'AT': ['Europe/Vienna'],
  'AU': ['Australia/Lord_Howe', 'Antarctica/Macquarie', 'Australia/Hobart', 'Australia/Currie', 'Australia/Melbourne', 'Australia/Sydney', 'Australia/Broken_Hill', 'Australia/Brisbane', 'Australia/Lindeman', 'Australia/Adelaide', 'Australia/Darwin', 'Australia/Perth', 'Australia/Eucla'],
  'AW': ['America/Aruba'],
  'AX': ['Europe/Mariehamn'],
  'AZ': ['Asia/Baku'],
  'BA': ['Europe/Sarajevo'],
  'BB': ['America/Barbados'],
  'BD': ['Asia/Dhaka'],
  'BE': ['Europe/Brussels'],
  'BF': ['Africa/Ouagadougou'],
  'BG': ['Europe/Sofia'],
  'BH': ['Asia/Bahrain'],
  'BI': ['Africa/Bujumbura'],
  'BJ': ['Africa/Porto-Novo'],
  'BL': ['America/St_Barthelemy'],
  'BM': ['Atlantic/Bermuda'],
  'BN': ['Asia/Brunei'],
  'BO': ['America/La_Paz'],
  'BQ': ['America/Kralendijk'],
  'BR': ['America/Noronha', 'America/Belem', 'America/Fortaleza', 'America/Recife', 'America/Araguaina', 'America/Maceio', 'America/Bahia', 'America/Sao_Paulo', 'America/Campo_Grande', 'America/Cuiaba', 'America/Santarem', 'America/Porto_Velho', 'America/Boa_Vista', 'America/Manaus', 'America/Eirunepe', 'America/Rio_Branco'],
  'BS': ['America/Nassau'],
  'BT': ['Asia/Thimphu'],
  'BV': ['Europe/Oslo'],
  'BW': ['Africa/Gaborone'],
  'BY': ['Europe/Minsk'],
  'BZ': ['America/Belize'],
  'CA': ['America/St_Johns', 'America/Halifax', 'America/Glace_Bay', 'America/Moncton', 'America/Goose_Bay', 'America/Blanc-Sablon', 'America/Toronto', 'America/Nipigon', 'America/Thunder_Bay', 'America/Iqaluit', 'America/Pangnirtung', 'America/Atikokan', 'America/Winnipeg', 'America/Rainy_River', 'America/Resolute', 'America/Rankin_Inlet', 'America/Regina', 'America/Swift_Current', 'America/Edmonton', 'America/Cambridge_Bay', 'America/Yellowknife', 'America/Inuvik', 'America/Creston', 'America/Dawson_Creek', 'America/Fort_Nelson', 'America/Vancouver', 'America/Whitehorse', 'America/Dawson'],
  'CC': ['Indian/Cocos'],
  'CD': ['Africa/Kinshasa', 'Africa/Lubumbashi'],
  'CF': ['Africa/Bangui'],
  'CG': ['Africa/Brazzaville'],
  'CH': ['Europe/Zurich'],
  'CI': ['Africa/Abidjan'],
  'CK': ['Pacific/Rarotonga'],
  'CL': ['America/Santiago', 'America/Punta_Arenas', 'Pacific/Easter'],
  'CM': ['Africa/Douala'],
  'CN': ['Asia/Shanghai', 'Asia/Urumqi'],
  'CO': ['America/Bogota'],
  'CR': ['America/Costa_Rica'],
  'CU': ['America/Havana'],
  'CV': ['Atlantic/Cape_Verde'],
  'CW': ['America/Curacao'],
  'CX': ['Indian/Christmas'],
  'CY': ['Asia/Nicosia', 'Asia/Famagusta'],
  'CZ': ['Europe/Prague'],
  'DE': ['Europe/Berlin', 'Europe/Busingen'],
  'DJ': ['Africa/Djibouti'],
  'DK': ['Europe/Copenhagen'],
  'DM': ['America/Dominica'],
  'DO': ['America/Santo_Domingo'],
  'DZ': ['Africa/Algiers'],
  'EC': ['America/Guayaquil', 'Pacific/Galapagos'],
  'EE': ['Europe/Tallinn'],
  'EG': ['Africa/Cairo'],
  'EH': ['Africa/El_Aaiun'],
  'ER': ['Africa/Asmara'],
  'ES': ['Europe/Madrid', 'Africa/Ceuta', 'Atlantic/Canary'],
  'ET': ['Africa/Addis_Ababa'],
  'FI': ['Europe/Helsinki'],
  'FJ': ['Pacific/Fiji'],
  'FK': ['Atlantic/Stanley'],
  'FM': ['Pacific/Chuuk', 'Pacific/Pohnpei', 'Pacific/Kosrae'],
  'FO': ['Atlantic/Faroe'],
  'FR': ['Europe/Paris'],
  'GA': ['Africa/Libreville'],
  'GB': ['Europe/London'],
  'GD': ['America/Grenada'],
  'GE': ['Asia/Tbilisi'],
  'GF': ['America/Cayenne'],
  'GG': ['Europe/Guernsey'],
  'GH': ['Africa/Accra'],
  'GI': ['Europe/Gibraltar'],
  'GL': ['America/Godthab', 'America/Danmarkshavn', 'America/Scoresbysund', 'America/Thule'],
  'GM': ['Africa/Banjul'],
  'GN': ['Africa/Conakry'],
  'GP': ['America/Guadeloupe'],
  'GQ': ['Africa/Malabo'],
  'GR': ['Europe/Athens'],
  'GS': ['Atlantic/South_Georgia'],
  'GT': ['America/Guatemala'],
  'GU': ['Pacific/Guam'],
  'GW': ['Africa/Bissau'],
  'GY': ['America/Guyana'],
  'HK': ['Asia/Hong_Kong'],
  'HM': ['Indian/Kerguelen'],
  'HN': ['America/Tegucigalpa'],
  'HR': ['Europe/Zagreb'],
  'HT': ['America/Port-au-Prince'],
  'HU': ['Europe/Budapest'],
  'ID': ['Asia/Jakarta', 'Asia/Pontianak', 'Asia/Makassar', 'Asia/Jayapura'],
  'IE': ['Europe/Dublin'],
  'IL': ['Asia/Jerusalem'],
  'IM': ['Europe/Isle_of_Man'],
  'IN': ['Asia/Kolkata'],
  'IO': ['Indian/Chagos'],
  'IQ': ['Asia/Baghdad'],
  'IR': ['Asia/Tehran'],
  'IS': ['Atlantic/Reykjavik'],
  'IT': ['Europe/Rome'],
  'JE': ['Europe/Jersey'],
  'JM': ['America/Jamaica'],
  'JO': ['Asia/Amman'],
  'JP': ['Asia/Tokyo'],
  'KE': ['Africa/Nairobi'],
  'KG': ['Asia/Bishkek'],
  'KH': ['Asia/Phnom_Penh'],
  'KI': ['Pacific/Tarawa', 'Pacific/Enderbury', 'Pacific/Kiritimati'],
  'KM': ['Indian/Comoro'],
  'KN': ['America/St_Kitts'],
  'KP': ['Asia/Pyongyang'],
  'KR': ['Asia/Seoul'],
  'KW': ['Asia/Kuwait'],
  'KY': ['America/Cayman'],
  'KZ': ['Asia/Almaty', 'Asia/Qyzylorda', 'Asia/Qostanay', 'Asia/Aqtobe', 'Asia/Aqtau', 'Asia/Atyrau'],
  'LA': ['Asia/Vientiane'],
  'LB': ['Asia/Beirut'],
  'LC': ['America/St_Lucia'],
  'LI': ['Europe/Vaduz'],
  'LK': ['Asia/Colombo'],
  'LR': ['Africa/Monrovia'],
  'LS': ['Africa/Maseru'],
  'LT': ['Europe/Vilnius'],
  'LU': ['Europe/Luxembourg'],
  'LV': ['Europe/Riga'],
  'LY': ['Africa/Tripoli'],
  'MA': ['Africa/Casablanca'],
  'MC': ['Europe/Monaco'],
  'MD': ['Europe/Chisinau'],
  'ME': ['Europe/Podgorica'],
  'MF': ['America/Marigot'],
  'MG': ['Indian/Antananarivo'],
  'MH': ['Pacific/Majuro', 'Pacific/Kwajalein'],
  'MK': ['Europe/Skopje'],
  'ML': ['Africa/Bamako'],
  'MM': ['Asia/Yangon'],
  'MN': ['Asia/Ulaanbaatar', 'Asia/Hovd', 'Asia/Choibalsan'],
  'MO': ['Asia/Macau'],
  'MP': ['Pacific/Saipan'],
  'MQ': ['America/Martinique'],
  'MR': ['Africa/Nouakchott'],
  'MS': ['America/Montserrat'],
  'MT': ['Europe/Malta'],
  'MU': ['Indian/Mauritius'],
  'MV': ['Indian/Maldives'],
  'MW': ['Africa/Blantyre'],
  'MX': ['America/Mexico_City', 'America/Cancun', 'America/Merida', 'America/Monterrey', 'America/Matamoros', 'America/Mazatlan', 'America/Chihuahua', 'America/Ojinaga', 'America/Hermosillo', 'America/Tijuana', 'America/Bahia_Banderas'],
  'MY': ['Asia/Kuala_Lumpur', 'Asia/Kuching'],
  'MZ': ['Africa/Maputo'],
  'NA': ['Africa/Windhoek'],
  'NC': ['Pacific/Noumea'],
  'NE': ['Africa/Niamey'],
  'NF': ['Pacific/Norfolk'],
  'NG': ['Africa/Lagos'],
  'NI': ['America/Managua'],
  'NL': ['Europe/Amsterdam'],
  'NO': ['Europe/Oslo'],
  'NP': ['Asia/Kathmandu'],
  'NR': ['Pacific/Nauru'],
  'NU': ['Pacific/Niue'],
  'NZ': ['Pacific/Auckland', 'Pacific/Chatham'],
  'OM': ['Asia/Muscat'],
  'PA': ['America/Panama'],
  'PE': ['America/Lima'],
  'PF': ['Pacific/Tahiti', 'Pacific/Marquesas', 'Pacific/Gambier'],
  'PG': ['Pacific/Port_Moresby', 'Pacific/Bougainville'],
  'PH': ['Asia/Manila'],
  'PK': ['Asia/Karachi'],
  'PL': ['Europe/Warsaw'],
  'PM': ['America/Miquelon'],
  'PN': ['Pacific/Pitcairn'],
  'PR': ['America/Puerto_Rico'],
  'PS': ['Asia/Gaza', 'Asia/Hebron'],
  'PT': ['Europe/Lisbon', 'Atlantic/Madeira', 'Atlantic/Azores'],
  'PW': ['Pacific/Palau'],
  'PY': ['America/Asuncion'],
  'QA': ['Asia/Qatar'],
  'RE': ['Indian/Reunion'],
  'RO': ['Europe/Bucharest'],
  'RS': ['Europe/Belgrade'],
  'RU': ['Europe/Kaliningrad', 'Europe/Moscow', 'Europe/Simferopol', 'Europe/Kirov', 'Europe/Astrakhan', 'Europe/Volgograd', 'Europe/Saratov', 'Europe/Ulyanovsk', 'Europe/Samara', 'Asia/Yekaterinburg', 'Asia/Omsk', 'Asia/Novosibirsk', 'Asia/Barnaul', 'Asia/Tomsk', 'Asia/Novokuznetsk', 'Asia/Krasnoyarsk', 'Asia/Irkutsk', 'Asia/Chita', 'Asia/Yakutsk', 'Asia/Khandyga', 'Asia/Vladivostok', 'Asia/Ust-Nera', 'Asia/Magadan', 'Asia/Sakhalin', 'Asia/Srednekolymsk', 'Asia/Kamchatka', 'Asia/Anadyr'],
  'RW': ['Africa/Kigali'],
  'SA': ['Asia/Riyadh'],
  'SB': ['Pacific/Guadalcanal'],
  'SC': ['Indian/Mahe'],
  'SD': ['Africa/Khartoum'],
  'SE': ['Europe/Stockholm'],
  'SG': ['Asia/Singapore'],
  'SH': ['Atlantic/St_Helena'],
  'SI': ['Europe/Ljubljana'],
  'SJ': ['Arctic/Longyearbyen'],
  'SK': ['Europe/Bratislava'],
  'SL': ['Africa/Freetown'],
  'SM': ['Europe/San_Marino'],
  'SN': ['Africa/Dakar'],
  'SO': ['Africa/Mogadishu'],
  'SR': ['America/Paramaribo'],
  'SS': ['Africa/Juba'],
  'ST': ['Africa/Sao_Tome'],
  'SV': ['America/El_Salvador'],
  'SX': ['America/Lower_Princes'],
  'SY': ['Asia/Damascus'],
  'SZ': ['Africa/Mbabane'],
  'TC': ['America/Grand_Turk'],
  'TD': ['Africa/Ndjamena'],
  'TF': ['Indian/Kerguelen'],
  'TG': ['Africa/Lome'],
  'TH': ['Asia/Bangkok'],
  'TJ': ['Asia/Dushanbe'],
  'TK': ['Pacific/Fakaofo'],
  'TL': ['Asia/Dili'],
  'TM': ['Asia/Ashgabat'],
  'TN': ['Africa/Tunis'],
  'TO': ['Pacific/Tongatapu'],
  'TR': ['Europe/Istanbul'],
  'TT': ['America/Port_of_Spain'],
  'TV': ['Pacific/Funafuti'],
  'TW': ['Asia/Taipei'],
  'TZ': ['Africa/Dar_es_Salaam'],
  'UA': ['Europe/Kiev', 'Europe/Uzhgorod', 'Europe/Zaporozhye'],
  'UG': ['Africa/Kampala'],
  'UM': ['Pacific/Johnston', 'Pacific/Midway', 'Pacific/Wake'],
  'US': ['America/New_York', 'America/Detroit', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Indiana/Indianapolis', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Vevay', 'America/Chicago', 'America/Indiana/Tell_City', 'America/Indiana/Knox', 'America/Menominee', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/North_Dakota/Beulah', 'America/Denver', 'America/Boise', 'America/Phoenix', 'America/Los_Angeles', 'America/Anchorage', 'America/Juneau', 'America/Sitka', 'America/Metlakatla', 'America/Yakutat', 'America/Nome', 'America/Adak', 'Pacific/Honolulu'],
  'UY': ['America/Montevideo'],
  'UZ': ['Asia/Samarkand', 'Asia/Tashkent'],
  'VA': ['Europe/Vatican'],
  'VC': ['America/St_Vincent'],
  'VE': ['America/Caracas'],
  'VG': ['America/Tortola'],
  'VI': ['America/St_Thomas'],
  'VN': ['Asia/Ho_Chi_Minh'],
  'VU': ['Pacific/Efate'],
  'WF': ['Pacific/Wallis'],
  'WS': ['Pacific/Apia'],
  'YE': ['Asia/Aden'],
  'YT': ['Indian/Mayotte'],
  'ZA': ['Africa/Johannesburg'],
  'ZM': ['Africa/Lusaka'],
  'ZW': ['Africa/Harare']
};

export const timezoneLabels = {
  'Europe/Andorra': 'Central European Time (UTC+1/+2)',
  'Asia/Dubai': 'Gulf Standard Time (UTC+4)',
  'Asia/Kabul': 'Afghanistan Time (UTC+4:30)',
  'America/Antigua': 'Atlantic Standard Time (UTC-4)',
  'America/Anguilla': 'Atlantic Standard Time (UTC-4)',
  'Europe/Tirane': 'Central European Time (UTC+1/+2)',
  'Asia/Yerevan': 'Armenia Time (UTC+4)',
  'Africa/Luanda': 'West Africa Time (UTC+1)',
  'Antarctica/McMurdo': 'New Zealand Daylight Time (UTC+13)',
  'Antarctica/Casey': 'Australian Western Standard Time (UTC+8)',
  'Antarctica/Davis': 'Davis Time (UTC+7)',
  'Antarctica/DumontDUrville': 'Dumont-d\'Urville Time (UTC+10)',
  'Antarctica/Mawson': 'Mawson Station Time (UTC+5)',
  'Antarctica/Palmer': 'Chile Summer Time (UTC-3)',
  'Antarctica/Rothera': 'Rothera Research Station Time (UTC-3)',
  'Antarctica/Syowa': 'Syowa Station Time (UTC+3)',
  'Antarctica/Troll': 'Coordinated Universal Time (UTC+0/+2)',
  'Antarctica/Vostok': 'Vostok Station Time (UTC+6)',
  'America/Argentina/Buenos_Aires': 'Argentina Time (UTC-3)',
  'America/Argentina/Cordoba': 'Argentina Time (UTC-3)',
  'America/Argentina/Salta': 'Argentina Time (UTC-3)',
  'America/Argentina/Jujuy': 'Argentina Time (UTC-3)',
  'America/Argentina/Tucuman': 'Argentina Time (UTC-3)',
  'America/Argentina/Catamarca': 'Argentina Time (UTC-3)',
  'America/Argentina/La_Rioja': 'Argentina Time (UTC-3)',
  'America/Argentina/San_Juan': 'Argentina Time (UTC-3)',
  'America/Argentina/Mendoza': 'Argentina Time (UTC-3)',
  'America/Argentina/San_Luis': 'Argentina Time (UTC-3)',
  'America/Argentina/Rio_Gallegos': 'Argentina Time (UTC-3)',
  'America/Argentina/Ushuaia': 'Argentina Time (UTC-3)',
  'Pacific/Pago_Pago': 'Samoa Standard Time (UTC-11)',
  'Europe/Vienna': 'Central European Time (UTC+1/+2)',
  'Australia/Lord_Howe': 'Lord Howe Standard Time (UTC+10:30/+11)',
  'Antarctica/Macquarie': 'Macquarie Island Time (UTC+11)',
  'Australia/Hobart': 'Australian Eastern Standard Time (UTC+10/+11)',
  'Australia/Currie': 'Australian Eastern Standard Time (UTC+10/+11)',
  'Australia/Melbourne': 'Australian Eastern Standard Time (UTC+10/+11)',
  'Australia/Sydney': 'Australian Eastern Standard Time (UTC+10/+11)',
  'Australia/Broken_Hill': 'Australian Central Standard Time (UTC+9:30/+10:30)',
  'Australia/Brisbane': 'Australian Eastern Standard Time (UTC+10)',
  'Australia/Lindeman': 'Australian Eastern Standard Time (UTC+10)',
  'Australia/Adelaide': 'Australian Central Standard Time (UTC+9:30/+10:30)',
  'Australia/Darwin': 'Australian Central Standard Time (UTC+9:30)',
  'Australia/Perth': 'Australian Western Standard Time (UTC+8)',
  'Australia/Eucla': 'Australian Central Western Standard Time (UTC+8:45)',
  'America/Aruba': 'Atlantic Standard Time (UTC-4)',
  'Europe/Mariehamn': 'Eastern European Time (UTC+2/+3)',
  'Asia/Baku': 'Azerbaijan Time (UTC+4)',
  'Europe/Sarajevo': 'Central European Time (UTC+1/+2)',
  'America/Barbados': 'Atlantic Standard Time (UTC-4)',
  'Asia/Dhaka': 'Bangladesh Standard Time (UTC+6)',
  'Europe/Brussels': 'Central European Time (UTC+1/+2)',
  'Africa/Ouagadougou': 'Greenwich Mean Time (UTC+0)',
  'Europe/Sofia': 'Eastern European Time (UTC+2/+3)',
  'Asia/Bahrain': 'Arabia Standard Time (UTC+3)',
  'Africa/Bujumbura': 'Central Africa Time (UTC+2)',
  'Africa/Porto-Novo': 'West Africa Time (UTC+1)',
  'America/St_Barthelemy': 'Atlantic Standard Time (UTC-4)',
  'Atlantic/Bermuda': 'Atlantic Standard Time (UTC-4/-3)',
  'Asia/Brunei': 'Brunei Time (UTC+8)',
  'America/La_Paz': 'Bolivia Time (UTC-4)',
  'America/Kralendijk': 'Atlantic Standard Time (UTC-4)',
  'America/Noronha': 'Fernando de Noronha Time (UTC-2)',
  'America/Belem': 'Brasilia Time (UTC-3)',
  'America/Fortaleza': 'Brasilia Time (UTC-3)',
  'America/Recife': 'Brasilia Time (UTC-3)',
  'America/Araguaina': 'Brasilia Time (UTC-3)',
  'America/Maceio': 'Brasilia Time (UTC-3)',
  'America/Bahia': 'Brasilia Time (UTC-3)',
  'America/Sao_Paulo': 'Brasilia Time (UTC-3/-2)',
  'America/Campo_Grande': 'Amazon Time (UTC-4/-3)',
  'America/Cuiaba': 'Amazon Time (UTC-4/-3)',
  'America/Santarem': 'Brasilia Time (UTC-3)',
  'America/Porto_Velho': 'Amazon Time (UTC-4)',
  'America/Boa_Vista': 'Amazon Time (UTC-4)',
  'America/Manaus': 'Amazon Time (UTC-4)',
  'America/Eirunepe': 'Acre Time (UTC-5)',
  'America/Rio_Branco': 'Acre Time (UTC-5)',
  'America/Nassau': 'Eastern Standard Time (UTC-5/-4)',
  'Asia/Thimphu': 'Bhutan Time (UTC+6)',
  'Europe/Oslo': 'Central European Time (UTC+1/+2)',
  'Africa/Gaborone': 'Central Africa Time (UTC+2)',
  'Europe/Minsk': 'Moscow Time (UTC+3)',
  'America/Belize': 'Central Standard Time (UTC-6)',
  'America/St_Johns': 'Newfoundland Standard Time (UTC-3:30/-2:30)',
  'America/Halifax': 'Atlantic Standard Time (UTC-4/-3)',
  'America/Glace_Bay': 'Atlantic Standard Time (UTC-4/-3)',
  'America/Moncton': 'Atlantic Standard Time (UTC-4/-3)',
  'America/Goose_Bay': 'Atlantic Standard Time (UTC-4/-3)',
  'America/Blanc-Sablon': 'Atlantic Standard Time (UTC-4)',
  'America/Toronto': 'Eastern Standard Time (UTC-5/-4)',
  'America/Nipigon': 'Eastern Standard Time (UTC-5/-4)',
  'America/Thunder_Bay': 'Eastern Standard Time (UTC-5/-4)',
  'America/Iqaluit': 'Eastern Standard Time (UTC-5/-4)',
  'America/Pangnirtung': 'Eastern Standard Time (UTC-5/-4)',
  'America/Atikokan': 'Eastern Standard Time (UTC-5)',
  'America/Winnipeg': 'Central Standard Time (UTC-6/-5)',
  'America/Rainy_River': 'Central Standard Time (UTC-6/-5)',
  'America/Resolute': 'Central Standard Time (UTC-6/-5)',
  'America/Rankin_Inlet': 'Central Standard Time (UTC-6/-5)',
  'America/Regina': 'Central Standard Time (UTC-6)',
  'America/Swift_Current': 'Central Standard Time (UTC-6)',
  'America/Edmonton': 'Mountain Standard Time (UTC-7/-6)',
  'America/Cambridge_Bay': 'Mountain Standard Time (UTC-7/-6)',
  'America/Yellowknife': 'Mountain Standard Time (UTC-7/-6)',
  'America/Inuvik': 'Mountain Standard Time (UTC-7/-6)',
  'America/Creston': 'Mountain Standard Time (UTC-7)',
  'America/Dawson_Creek': 'Mountain Standard Time (UTC-7)',
  'America/Fort_Nelson': 'Mountain Standard Time (UTC-7)',
  'America/Vancouver': 'Pacific Standard Time (UTC-8/-7)',
  'America/Whitehorse': 'Pacific Standard Time (UTC-8/-7)',
  'America/Dawson': 'Pacific Standard Time (UTC-8/-7)',
  'Indian/Cocos': 'Cocos Islands Time (UTC+6:30)',
  'Africa/Kinshasa': 'West Africa Time (UTC+1)',
  'Africa/Lubumbashi': 'Central Africa Time (UTC+2)',
  'Africa/Bangui': 'West Africa Time (UTC+1)',
  'Africa/Brazzaville': 'West Africa Time (UTC+1)',
  'Europe/Zurich': 'Central European Time (UTC+1/+2)',
  'Africa/Abidjan': 'Greenwich Mean Time (UTC+0)',
  'Pacific/Rarotonga': 'Cook Island Time (UTC-10)',
  'America/Santiago': 'Chile Standard Time (UTC-4/-3)',
  'America/Punta_Arenas': 'Chile Standard Time (UTC-3)',
  'Pacific/Easter': 'Easter Island Standard Time (UTC-6/-5)',
  'Africa/Douala': 'West Africa Time (UTC+1)',
  'Asia/Shanghai': 'China Standard Time (UTC+8)',
  'Asia/Urumqi': 'Xinjiang Time (UTC+6)',
  'America/Bogota': 'Colombia Time (UTC-5)',
  'America/Costa_Rica': 'Central Standard Time (UTC-6)',
  'America/Havana': 'Cuba Standard Time (UTC-5/-4)',
  'Atlantic/Cape_Verde': 'Cape Verde Time (UTC-1)',
  'America/Curacao': 'Atlantic Standard Time (UTC-4)',
  'Indian/Christmas': 'Christmas Island Time (UTC+7)',
  'Asia/Nicosia': 'Eastern European Time (UTC+2/+3)',
  'Asia/Famagusta': 'Eastern European Time (UTC+2/+3)',
  'Europe/Prague': 'Central European Time (UTC+1/+2)',
  'Europe/Berlin': 'Central European Time (UTC+1/+2)',
  'Europe/Busingen': 'Central European Time (UTC+1/+2)',
  'Africa/Djibouti': 'East Africa Time (UTC+3)',
  'Europe/Copenhagen': 'Central European Time (UTC+1/+2)',
  'America/Dominica': 'Atlantic Standard Time (UTC-4)',
  'America/Santo_Domingo': 'Atlantic Standard Time (UTC-4)',
  'Africa/Algiers': 'Central European Time (UTC+1)',
  'America/Guayaquil': 'Ecuador Time (UTC-5)',
  'Pacific/Galapagos': 'Galapagos Time (UTC-6)',
  'Europe/Tallinn': 'Eastern European Time (UTC+2/+3)',
  'Africa/Cairo': 'Eastern European Time (UTC+2)',
  'Africa/El_Aaiun': 'Western European Time (UTC+0/+1)',
  'Africa/Asmara': 'East Africa Time (UTC+3)',
  'Europe/Madrid': 'Central European Time (UTC+1/+2)',
  'Africa/Ceuta': 'Central European Time (UTC+1/+2)',
  'Atlantic/Canary': 'Western European Time (UTC+0/+1)',
  'Africa/Addis_Ababa': 'East Africa Time (UTC+3)',
  'Europe/Helsinki': 'Eastern European Time (UTC+2/+3)',
  'Pacific/Fiji': 'Fiji Time (UTC+12/+13)',
  'Atlantic/Stanley': 'Falkland Islands Time (UTC-3)',
  'Pacific/Chuuk': 'Chuuk Time (UTC+10)',
  'Pacific/Pohnpei': 'Ponape Time (UTC+11)',
  'Pacific/Kosrae': 'Kosrae Time (UTC+11)',
  'Atlantic/Faroe': 'Western European Time (UTC+0/+1)',
  'Europe/Paris': 'Central European Time (UTC+1/+2)',
  'Africa/Libreville': 'West Africa Time (UTC+1)',
  'Europe/London': 'Greenwich Mean Time (UTC+0/+1)',
  'America/Grenada': 'Atlantic Standard Time (UTC-4)',
  'Asia/Tbilisi': 'Georgia Standard Time (UTC+4)',
  'America/Cayenne': 'French Guiana Time (UTC-3)',
  'Europe/Guernsey': 'Greenwich Mean Time (UTC+0/+1)',
  'Africa/Accra': 'Greenwich Mean Time (UTC+0)',
  'Europe/Gibraltar': 'Central European Time (UTC+1/+2)',
  'America/Godthab': 'West Greenland Time (UTC-3/-2)',
  'America/Danmarkshavn': 'Greenwich Mean Time (UTC+0)',
  'America/Scoresbysund': 'East Greenland Time (UTC-1/+0)',
  'America/Thule': 'Atlantic Standard Time (UTC-4/-3)',
  'Africa/Banjul': 'Greenwich Mean Time (UTC+0)',
  'Africa/Conakry': 'Greenwich Mean Time (UTC+0)',
  'America/Guadeloupe': 'Atlantic Standard Time (UTC-4)',
  'Africa/Malabo': 'West Africa Time (UTC+1)',
  'Europe/Athens': 'Eastern European Time (UTC+2/+3)',
  'Atlantic/South_Georgia': 'South Georgia and the South Sandwich Islands Time (UTC-2)',
  'America/Guatemala': 'Central Standard Time (UTC-6)',
  'Pacific/Guam': 'Chamorro Standard Time (UTC+10)',
  'Africa/Bissau': 'Greenwich Mean Time (UTC+0)',
  'America/Guyana': 'Guyana Time (UTC-4)',
  'Asia/Hong_Kong': 'Hong Kong Time (UTC+8)',
  'Indian/Kerguelen': 'French Southern and Antarctic Time (UTC+5)',
  'America/Tegucigalpa': 'Central Standard Time (UTC-6)',
  'Europe/Zagreb': 'Central European Time (UTC+1/+2)',
  'America/Port-au-Prince': 'Eastern Standard Time (UTC-5/-4)',
  'Europe/Budapest': 'Central European Time (UTC+1/+2)',
  'Asia/Jakarta': 'Western Indonesia Time (UTC+7)',
  'Asia/Pontianak': 'Western Indonesia Time (UTC+7)',
  'Asia/Makassar': 'Central Indonesia Time (UTC+8)',
  'Asia/Jayapura': 'Eastern Indonesia Time (UTC+9)',
  'Europe/Dublin': 'Greenwich Mean Time (UTC+0/+1)',
  'Asia/Jerusalem': 'Israel Standard Time (UTC+2/+3)',
  'Europe/Isle_of_Man': 'Greenwich Mean Time (UTC+0/+1)',
  'Asia/Kolkata': 'India Standard Time (UTC+5:30)',
  'Indian/Chagos': 'Indian Ocean Time (UTC+6)',
  'Asia/Baghdad': 'Arabia Standard Time (UTC+3)',
  'Asia/Tehran': 'Iran Standard Time (UTC+3:30/+4:30)',
  'Atlantic/Reykjavik': 'Greenwich Mean Time (UTC+0)',
  'Europe/Rome': 'Central European Time (UTC+1/+2)',
  'Europe/Jersey': 'Greenwich Mean Time (UTC+0/+1)',
  'America/Jamaica': 'Eastern Standard Time (UTC-5)',
  'Asia/Amman': 'Eastern European Time (UTC+2/+3)',
  'Asia/Tokyo': 'Japan Standard Time (UTC+9)',
  'Africa/Nairobi': 'East Africa Time (UTC+3)',
  'Asia/Bishkek': 'Kyrgyzstan Time (UTC+6)',
  'Asia/Phnom_Penh': 'Indochina Time (UTC+7)',
  'Pacific/Tarawa': 'Gilbert Island Time (UTC+12)',
  'Pacific/Enderbury': 'Phoenix Island Time (UTC+13)',
  'Pacific/Kiritimati': 'Line Islands Time (UTC+14)',
  'Indian/Comoro': 'East Africa Time (UTC+3)',
  'America/St_Kitts': 'Atlantic Standard Time (UTC-4)',
  'Asia/Pyongyang': 'Pyongyang Time (UTC+9)',
  'Asia/Seoul': 'Korea Standard Time (UTC+9)',
  'Asia/Kuwait': 'Arabia Standard Time (UTC+3)',
  'America/Cayman': 'Eastern Standard Time (UTC-5)',
  'Asia/Almaty': 'Almaty Time (UTC+6)',
  'Asia/Qyzylorda': 'Qyzylorda Time (UTC+5)',
  'Asia/Qostanay': 'Qostanay Time (UTC+6)',
  'Asia/Aqtobe': 'Aqtobe Time (UTC+5)',
  'Asia/Aqtau': 'Aqtau Time (UTC+5)',
  'Asia/Atyrau': 'Atyrau Time (UTC+5)',
  'Asia/Vientiane': 'Indochina Time (UTC+7)',
  'Asia/Beirut': 'Eastern European Time (UTC+2/+3)',
  'America/St_Lucia': 'Atlantic Standard Time (UTC-4)',
  'Europe/Vaduz': 'Central European Time (UTC+1/+2)',
  'Asia/Colombo': 'India Standard Time (UTC+5:30)',
  'Africa/Monrovia': 'Greenwich Mean Time (UTC+0)',
  'Africa/Maseru': 'South Africa Standard Time (UTC+2)',
  'Europe/Vilnius': 'Eastern European Time (UTC+2/+3)',
  'Europe/Luxembourg': 'Central European Time (UTC+1/+2)',
  'Europe/Riga': 'Eastern European Time (UTC+2/+3)',
  'Africa/Tripoli': 'Eastern European Time (UTC+2)',
  'Africa/Casablanca': 'Western European Time (UTC+0/+1)',
  'Europe/Monaco': 'Central European Time (UTC+1/+2)',
  'Europe/Chisinau': 'Eastern European Time (UTC+2/+3)',
  'Europe/Podgorica': 'Central European Time (UTC+1/+2)',
  'America/Marigot': 'Atlantic Standard Time (UTC-4)',
  'Indian/Antananarivo': 'East Africa Time (UTC+3)',
  'Pacific/Majuro': 'Marshall Islands Time (UTC+12)',
  'Pacific/Kwajalein': 'Marshall Islands Time (UTC+12)',
  'Europe/Skopje': 'Central European Time (UTC+1/+2)',
  'Africa/Bamako': 'Greenwich Mean Time (UTC+0)',
  'Asia/Yangon': 'Myanmar Time (UTC+6:30)',
  'Asia/Ulaanbaatar': 'Ulaanbaatar Time (UTC+8)',
  'Asia/Hovd': 'Hovd Time (UTC+7)',
  'Asia/Choibalsan': 'Choibalsan Time (UTC+8)',
  'Asia/Macau': 'China Standard Time (UTC+8)',
  'Pacific/Saipan': 'Chamorro Standard Time (UTC+10)',
  'America/Martinique': 'Atlantic Standard Time (UTC-4)',
  'Africa/Nouakchott': 'Greenwich Mean Time (UTC+0)',
  'America/Montserrat': 'Atlantic Standard Time (UTC-4)',
  'Europe/Malta': 'Central European Time (UTC+1/+2)',
  'Indian/Mauritius': 'Mauritius Time (UTC+4)',
  'Indian/Maldives': 'Maldives Time (UTC+5)',
  'Africa/Blantyre': 'Central Africa Time (UTC+2)',
  'America/Mexico_City': 'Central Standard Time (UTC-6/-5)',
  'America/Cancun': 'Eastern Standard Time (UTC-5)',
  'America/Merida': 'Central Standard Time (UTC-6/-5)',
  'America/Monterrey': 'Central Standard Time (UTC-6/-5)',
  'America/Matamoros': 'Central Standard Time (UTC-6/-5)',
  'America/Mazatlan': 'Mexican Pacific Standard Time (UTC-7/-6)',
  'America/Chihuahua': 'Mexican Pacific Standard Time (UTC-7/-6)',
  'America/Ojinaga': 'Mountain Standard Time (UTC-7/-6)',
  'America/Hermosillo': 'Mexican Pacific Standard Time (UTC-7)',
  'America/Tijuana': 'Pacific Standard Time (UTC-8/-7)',
  'America/Bahia_Banderas': 'Central Standard Time (UTC-6/-5)',
  'Asia/Kuala_Lumpur': 'Malaysia Time (UTC+8)',
  'Asia/Kuching': 'Malaysia Time (UTC+8)',
  'Africa/Maputo': 'Central Africa Time (UTC+2)',
  'Africa/Windhoek': 'Central Africa Time (UTC+2)',
  'Pacific/Noumea': 'New Caledonia Time (UTC+11)',
  'Africa/Niamey': 'West Africa Time (UTC+1)',
  'Pacific/Norfolk': 'Norfolk Time (UTC+11/+12)',
  'Africa/Lagos': 'West Africa Time (UTC+1)',
  'America/Managua': 'Central Standard Time (UTC-6)',
  'Europe/Amsterdam': 'Central European Time (UTC+1/+2)',
  'Asia/Kathmandu': 'Nepal Time (UTC+5:45)',
  'Pacific/Nauru': 'Nauru Time (UTC+12)',
  'Pacific/Niue': 'Niue Time (UTC-11)',
  'Pacific/Auckland': 'New Zealand Standard Time (UTC+12/+13)',
  'Pacific/Chatham': 'Chatham Standard Time (UTC+12:45/+13:45)',
  'Asia/Muscat': 'Gulf Standard Time (UTC+4)',
  'America/Panama': 'Eastern Standard Time (UTC-5)',
  'America/Lima': 'Peru Time (UTC-5)',
  'Pacific/Tahiti': 'Tahiti Time (UTC-10)',
  'Pacific/Marquesas': 'Marquesas Time (UTC-9:30)',
  'Pacific/Gambier': 'Gambier Time (UTC-9)',
  'Pacific/Port_Moresby': 'Papua New Guinea Time (UTC+10)',
  'Pacific/Bougainville': 'Bougainville Standard Time (UTC+11)',
  'Asia/Manila': 'Philippine Time (UTC+8)',
  'Asia/Karachi': 'Pakistan Standard Time (UTC+5)',
  'Europe/Warsaw': 'Central European Time (UTC+1/+2)',
  'America/Miquelon': 'Pierre & Miquelon Standard Time (UTC-3/-2)',
  'Pacific/Pitcairn': 'Pitcairn Standard Time (UTC-8)',
  'America/Puerto_Rico': 'Atlantic Standard Time (UTC-4)',
  'Asia/Gaza': 'Eastern European Time (UTC+2/+3)',
  'Asia/Hebron': 'Eastern European Time (UTC+2/+3)',
  'Europe/Lisbon': 'Western European Time (UTC+0/+1)',
  'Atlantic/Madeira': 'Western European Time (UTC+0/+1)',
  'Atlantic/Azores': 'Azores Time (UTC-1/+0)',
  'Pacific/Palau': 'Palau Time (UTC+9)',
  'America/Asuncion': 'Paraguay Time (UTC-3/-2)',
  'Asia/Qatar': 'Arabia Standard Time (UTC+3)',
  'Indian/Reunion': 'Réunion Time (UTC+4)',
  'Europe/Bucharest': 'Eastern European Time (UTC+2/+3)',
  'Europe/Belgrade': 'Central European Time (UTC+1/+2)',
  'Europe/Kaliningrad': 'Eastern European Time (UTC+2)',
  'Europe/Moscow': 'Moscow Time (UTC+3)',
  'Europe/Simferopol': 'Moscow Time (UTC+3)',
  'Europe/Kirov': 'Moscow Time (UTC+3)',
  'Europe/Astrakhan': 'Astrakhan Time (UTC+4)',
  'Europe/Volgograd': 'Moscow Time (UTC+3)',
  'Europe/Saratov': 'Saratov Time (UTC+4)',
  'Europe/Ulyanovsk': 'Ulyanovsk Time (UTC+4)',
  'Europe/Samara': 'Samara Time (UTC+4)',
  'Asia/Yekaterinburg': 'Yekaterinburg Time (UTC+5)',
  'Asia/Omsk': 'Omsk Time (UTC+6)',
  'Asia/Novosibirsk': 'Novosibirsk Time (UTC+7)',
  'Asia/Barnaul': 'Barnaul Time (UTC+7)',
  'Asia/Tomsk': 'Tomsk Time (UTC+7)',
  'Asia/Novokuznetsk': 'Krasnoyarsk Time (UTC+7)',
  'Asia/Krasnoyarsk': 'Krasnoyarsk Time (UTC+7)',
  'Asia/Irkutsk': 'Irkutsk Time (UTC+8)',
  'Asia/Chita': 'Yakutsk Time (UTC+9)',
  'Asia/Yakutsk': 'Yakutsk Time (UTC+9)',
  'Asia/Khandyga': 'Yakutsk Time (UTC+9)',
  'Asia/Vladivostok': 'Vladivostok Time (UTC+10)',
  'Asia/Ust-Nera': 'Vladivostok Time (UTC+10)',
  'Asia/Magadan': 'Magadan Time (UTC+11)',
  'Asia/Sakhalin': 'Sakhalin Time (UTC+11)',
  'Asia/Srednekolymsk': 'Srednekolymsk Time (UTC+11)',
  'Asia/Kamchatka': 'Petropavlovsk-Kamchatski Time (UTC+12)',
  'Asia/Anadyr': 'Anadyr Time (UTC+12)',
  'Africa/Kigali': 'Central Africa Time (UTC+2)',
  'Asia/Riyadh': 'Arabia Standard Time (UTC+3)',
  'Pacific/Guadalcanal': 'Solomon Is. Time (UTC+11)',
  'Indian/Mahe': 'Seychelles Time (UTC+4)',
  'Africa/Khartoum': 'Central Africa Time (UTC+2)',
  'Europe/Stockholm': 'Central European Time (UTC+1/+2)',
  'Asia/Singapore': 'Singapore Standard Time (UTC+8)',
  'Atlantic/St_Helena': 'Greenwich Mean Time (UTC+0)',
  'Europe/Ljubljana': 'Central European Time (UTC+1/+2)',
  'Arctic/Longyearbyen': 'Central European Time (UTC+1/+2)',
  'Europe/Bratislava': 'Central European Time (UTC+1/+2)',
  'Africa/Freetown': 'Greenwich Mean Time (UTC+0)',
  'Europe/San_Marino': 'Central European Time (UTC+1/+2)',
  'Africa/Dakar': 'Greenwich Mean Time (UTC+0)',
  'Africa/Mogadishu': 'East Africa Time (UTC+3)',
  'America/Paramaribo': 'Suriname Time (UTC-3)',
  'Africa/Juba': 'Central Africa Time (UTC+2)',
  'Africa/Sao_Tome': 'Greenwich Mean Time (UTC+0)',
  'America/El_Salvador': 'Central Standard Time (UTC-6)',
  'America/Lower_Princes': 'Atlantic Standard Time (UTC-4)',
  'Asia/Damascus': 'Eastern European Time (UTC+2/+3)',
  'Africa/Mbabane': 'South Africa Standard Time (UTC+2)',
  'America/Grand_Turk': 'Eastern Standard Time (UTC-5/-4)',
  'Africa/Ndjamena': 'West Africa Time (UTC+1)',
  'Africa/Lome': 'Greenwich Mean Time (UTC+0)',
  'Asia/Bangkok': 'Indochina Time (UTC+7)',
  'Asia/Dushanbe': 'Tajikistan Time (UTC+5)',
  'Pacific/Fakaofo': 'Tokelau Time (UTC+13)',
  'Asia/Dili': 'Timor-Leste Time (UTC+9)',
  'Asia/Ashgabat': 'Turkmenistan Time (UTC+5)',
  'Africa/Tunis': 'Central European Time (UTC+1)',
  'Pacific/Tongatapu': 'Tonga Time (UTC+13)',
  'Europe/Istanbul': 'Turkey Time (UTC+3)',
  'America/Port_of_Spain': 'Atlantic Standard Time (UTC-4)',
  'Pacific/Funafuti': 'Tuvalu Time (UTC+12)',
  'Asia/Taipei': 'Taipei Standard Time (UTC+8)',
  'Africa/Dar_es_Salaam': 'East Africa Time (UTC+3)',
  'Europe/Kiev': 'Eastern European Time (UTC+2/+3)',
  'Europe/Uzhgorod': 'Eastern European Time (UTC+2/+3)',
  'Europe/Zaporozhye': 'Eastern European Time (UTC+2/+3)',
  'Africa/Kampala': 'East Africa Time (UTC+3)',
  'Pacific/Johnston': 'Hawaii-Aleutian Standard Time (UTC-10)',
  'Pacific/Midway': 'Samoa Standard Time (UTC-11)',
  'Pacific/Wake': 'Wake Time (UTC+12)',
  'America/New_York': 'Eastern Standard Time (UTC-5/-4)',
  'America/Detroit': 'Eastern Standard Time (UTC-5/-4)',
  'America/Kentucky/Louisville': 'Eastern Standard Time (UTC-5/-4)',
  'America/Kentucky/Monticello': 'Eastern Standard Time (UTC-5/-4)',
  'America/Indiana/Indianapolis': 'Eastern Standard Time (UTC-5/-4)',
  'America/Indiana/Vincennes': 'Eastern Standard Time (UTC-5/-4)',
  'America/Indiana/Winamac': 'Eastern Standard Time (UTC-5/-4)',
  'America/Indiana/Marengo': 'Eastern Standard Time (UTC-5/-4)',
  'America/Indiana/Petersburg': 'Eastern Standard Time (UTC-5/-4)',
  'America/Indiana/Vevay': 'Eastern Standard Time (UTC-5/-4)',
  'America/Chicago': 'Central Standard Time (UTC-6/-5)',
  'America/Indiana/Tell_City': 'Central Standard Time (UTC-6/-5)',
  'America/Indiana/Knox': 'Central Standard Time (UTC-6/-5)',
  'America/Menominee': 'Central Standard Time (UTC-6/-5)',
  'America/North_Dakota/Center': 'Central Standard Time (UTC-6/-5)',
  'America/North_Dakota/New_Salem': 'Central Standard Time (UTC-6/-5)',
  'America/North_Dakota/Beulah': 'Central Standard Time (UTC-6/-5)',
  'America/Denver': 'Mountain Standard Time (UTC-7/-6)',
  'America/Boise': 'Mountain Standard Time (UTC-7/-6)',
  'America/Phoenix': 'Mountain Standard Time (UTC-7)',
  'America/Los_Angeles': 'Pacific Standard Time (UTC-8/-7)',
  'America/Anchorage': 'Alaska Standard Time (UTC-9/-8)',
  'America/Juneau': 'Alaska Standard Time (UTC-9/-8)',
  'America/Sitka': 'Alaska Standard Time (UTC-9/-8)',
  'America/Metlakatla': 'Alaska Standard Time (UTC-9/-8)',
  'America/Yakutat': 'Alaska Standard Time (UTC-9/-8)',
  'America/Nome': 'Alaska Standard Time (UTC-9/-8)',
  'America/Adak': 'Hawaii-Aleutian Standard Time (UTC-10/-9)',
  'Pacific/Honolulu': 'Hawaii-Aleutian Standard Time (UTC-10)',
  'America/Montevideo': 'Uruguay Standard Time (UTC-3/-2)',
  'Asia/Samarkand': 'Uzbekistan Time (UTC+5)',
  'Asia/Tashkent': 'Uzbekistan Time (UTC+5)',
  'Europe/Vatican': 'Central European Time (UTC+1/+2)',
  'America/St_Vincent': 'Atlantic Standard Time (UTC-4)',
  'America/Caracas': 'Venezuela Time (UTC-4)',
  'America/Tortola': 'Atlantic Standard Time (UTC-4)',
  'America/St_Thomas': 'Atlantic Standard Time (UTC-4)',
  'Asia/Ho_Chi_Minh': 'Indochina Time (UTC+7)',
  'Pacific/Efate': 'Vanuatu Time (UTC+11)',
  'Pacific/Wallis': 'Wallis & Futuna Time (UTC+12)',
  'Pacific/Apia': 'West Samoa Time (UTC+13)',
  'Asia/Aden': 'Arabia Standard Time (UTC+3)',
  'Indian/Mayotte': 'East Africa Time (UTC+3)',
  'Africa/Johannesburg': 'South Africa Standard Time (UTC+2)',
  'Africa/Lusaka': 'Central Africa Time (UTC+2)',
  'Africa/Harare': 'Central Africa Time (UTC+2)'
};